var en_us = {
    values: {
        Qualifier: 'Qualifier',
        URI: 'URL:',
        ClientId: 'Client ID:',
        ClientSecret: 'Client Secret:',
        Default: 'Default',
        'Import from': 'Import from Poço Web',
        'Could not request the configured resource': 'Could not request the configured resource',
        'Need to register at least one instance in well import configuration':
            'Need to register at least one instance in well import configuration',
        clickconfigure: 'Configure instance',
        SelectAll: 'Select All',
        'What data to import from': 'What data to import from',
        PorePresure: 'Pore pressure',
        FracturePressure: 'Fracture Pressure',
        Location: 'Location',
        'Only local connections are allowed': 'Only local connections are allowed',
        'Error. Verify the url and credentials.': 'Error. Verify the url and credentials.',
        TrustCertificate: 'Ignore SSL certificate',
        SearchWell: 'Search Wells...',
        'Need permissions to import data': 'Need permissions to import data',
        'seeds-import-data-message': 'Insert the intervention start date. This date will be' +
            ' used as start date for the first operation and follow operations dates will be' + 
            ' calculated based on its duration time.'
    }
}

module.exports = en_us
